import { render, staticRenderFns } from "./liferecordSvg.vue?vue&type=template&id=414f4e30"
import script from "./liferecordSvg.vue?vue&type=script&lang=ts"
export * from "./liferecordSvg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports